import * as yup from 'yup';

  const MAX_FILE_SIZE = 10485760;
  const validFileExtensions = {doc: ['pdf', 'docx', 'doc']};

  function isValidFileType(fileName, fileType) {
    return fileName && validFileExtensions[fileType].indexOf(fileName.split('.').pop()) > -1;
  }

export const applicantDataRules = {
    firstname: yup.string().required('Enter your first name').min(1).max(255),
    lastname: yup.string().required('Enter your last name').min(1).max(255),
    addressFirst: yup.string().required('Enter your address').min(1).max(255),
    addressSecond: yup.string().max(255),
    postCode: yup.string().required('Enter your postcode').min(1).max(255),
    city: yup.string().required('Enter your city').min(1).max(255),
    country: yup.string().required('Enter your country').min(1).max(255),
    email: yup.string().required('Enter your e-mail address').email('Enter your e-mail in the format yourname@example.com'),
    membership: yup.string().required('Choose your desired membership type'),
    privacyPolicy: yup.bool().required('You need to accept the terms and conditions').equals([true]),
    membershipCheckbox: yup.bool().required('You need to accept your membership').equals([true]),
    fileRequired: yup.mixed().required("Choose a document to upload")
    .test("is-valid-type", "The document has to be one of the following formats: PDF, DOC or DOCX",
      value => isValidFileType(value && value.name.toLowerCase(), "doc"))
    .test("is-valid-size", "The document is too large. (maximum 10 MB)",
      value => value && value.size <= MAX_FILE_SIZE),
    file: yup.mixed().notRequired()
      .test("is-valid-type", "The document has to be one of the following formats: PDF, DOC or DOCX",
        (value) => {
          if (value) {
            return isValidFileType(value && value.name.toLowerCase(), "doc")
          } else {
            return true
          }
        }
      )
      .test("is-valid-size", "The document is too large. (maximum 10 MB)",
        (value) => {
          if (value) {
            return value && value.size <= MAX_FILE_SIZE
          } else {
            return true;
          }
        }
      ),
  };
